
<div class="filter-container">

  <!-- Filter Group -->
  <div class="filter-group">
    <span class="group-label">Filters</span>
    <div class="userFilter" *ngIf="canAssignProbates()">
      <mat-form-field appearance="outline">
        <mat-label>Filter by User</mat-label>
        <mat-select [(value)]="selectedUserFilter" [compareWith]="compareUsers">
          <mat-option [value]="null">All</mat-option>
          <mat-option value="unassigned">Unassigned</mat-option>
          <mat-option *ngFor="let user of users" [value]="user">{{ user.firstName }} {{ user.lastName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="statusFilter">
      <mat-form-field appearance="outline">
        <mat-label>Filter by Status</mat-label>
        <mat-select multiple [(value)]="selectedStatusFilters">
          <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="nonCharitableFilter">
      <mat-checkbox [(ngModel)]="showNonCharitable">
        Show Non-Charitable
      </mat-checkbox>
    </div>
    <div class="filterSearchButton">
      <button mat-raised-button (click)="populateComponents()">Apply Filter</button>
    </div>
  </div>

  <!-- Search Group -->
  <div class="search-group">
    <span class="group-label">Search</span>
    <div class="deceasedNameSearch">
      <mat-form-field appearance="outline">
        <mat-label>Deceased Name Search</mat-label>
        <input matInput [(ngModel)]="nameSearchValue" placeholder="Enter deceased name..."
               [disabled]="probateSearchValue.trim().length > 0"
               (keyup.enter)="applySearch()">
        <button *ngIf="isNameSearchActive" matSuffix mat-icon-button (click)="clearNameSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="probateSearch">
      <mat-form-field appearance="outline">
        <mat-label>Probate Search</mat-label>
        <input matInput [(ngModel)]="probateSearchValue" placeholder="Enter Probate ID..."
               [disabled]="nameSearchValue.trim().length > 0"
               (keyup.enter)="applySearch()">
        <button *ngIf="isProbateSearchActive" matSuffix mat-icon-button (click)="clearProbateSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="dateFilter">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" readonly (click)="startPicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" readonly (click)="endPicker.open()">
        <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
      <button *ngIf="startDate || endDate" mat-icon-button class="clear-date-button"
              (click)="clearDateSearch()" matTooltip="Clear dates">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="searchButton">
      <button mat-raised-button (click)="applySearch()"
              [disabled]="!nameSearchValue.trim() && !probateSearchValue.trim() && !startDate && !endDate">Search</button>
    </div>
  </div>

  <div class="paginator">
    <mat-paginator #paginator
                   [pageSize]="pageSize"
                   [pageSizeOptions]="[50, 100, 200, 500]"
                   (page)="pageChanged($event)"
                   showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

  <!-- Selection Column -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="masterToggle()"
                    [checked]="isAllSelected()"
                    [indeterminate]="isSomeSelectedOnPage()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <!-- Case Reference Column (clickable) -->
  <ng-container matColumnDef="caseReferenceNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Case Ref</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'clickable-cell': true, 'selected-row': selection.isSelected(element)}">
      <button mat-raised-button class="selectProbate-button" (click)="goToReport(element)">
        {{ element.probateId }}
      </button>
    </td>
  </ng-container>

  <!-- Other Columns -->
  <ng-container matColumnDef="fullNameOfDeceased">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.deceasedName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="clientCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.subscribedCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="nonClientCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Client Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.nonSubscribedCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="charitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.charitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="nonCharitableBequestCount">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Non-Charitable</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.nonCharitableBequestCount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dateOfIssue">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Probate</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.dateOfIssue | date: 'dd/MM/yyyy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="weekOld">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Week Old</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ getWeekOld(element.dateOfIssue) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="assignedUser">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Assigned User</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.assignedUser?.firstName }} {{ element.assignedUser?.lastName }}
    </td>
  </ng-container>

  <!-- Reported By Column (Supervisors only) -->
  <ng-container matColumnDef="reportedBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Reported By</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.reportedByUser?.firstName }} {{ element.reportedByUser?.lastName }}
    </td>
  </ng-container>

  <!-- Verified By Column (Supervisors and System Administrators only) -->
  <ng-container matColumnDef="verifiedBy">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Verified By</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      {{ element.verifiedByUser?.firstName }} {{ element.verifiedByUser?.lastName }}
    </td>
  </ng-container>

  <!-- Has Notes Column -->
  <ng-container matColumnDef="hasNotes">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Has Notes</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      @if(element.noteCount > 0) {
        <span class="notes-trigger">
          <span class="has-notes-y">Y</span>
          <div class="notes-popover" (click)="$event.stopPropagation()">
            @for(n of element.notes; track n.id) {
              <div class="note-item">
                <div class="note-meta">{{ n.userDisplayName }} · {{ n.dateAdded | date:'dd/MM/yyyy HH:mm' }}</div>
                <div class="note-text">{{ n.textContent }}</div>
              </div>
            }
          </div>
        </span>
      } @else {
        <span>N</span>
      }
    </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let element" [ngClass]="{'selected-row': selection.isSelected(element)}">
      <span class="status-badge status-{{ element.status }}">{{ getStatusLabel(element.status) }}</span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'selected-row': selection.isSelected(row)}"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell no-records-cell" [attr.colspan]="displayedColumns.length">No Records Found</td>
  </tr>

</table>

<div *ngIf="canAssignProbates()" style="display: flex; justify-content: flex-end; padding-top: 12px; padding-right: 16px;">
  <mat-form-field appearance="outline" style="width: 200px; margin-right: 8px;">
    <mat-label>Assign To</mat-label>
    <mat-select [formControl]="assignToUserControl">
      <mat-option [value]="'unassign'">Unassign</mat-option>
      <mat-option *ngFor="let user of users" [value]="user">
        {{ user.firstName }} {{ user.lastName }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-raised-button class="assign-button" (click)="assignSelectedProbates()">
    Assign Selected
  </button>
</div>
